export default class FundingRequest {
  public static readonly LIST = '/funding-requests';
  public static readonly GET = '/funding-request/{id}';
  public static readonly GET_DOCUMENTS = '/funding-request/{id}/documents';
  public static readonly SUMMARY = '/funding-request/summary';
  public static readonly CREATE = '/funding-requests';
  public static readonly STATUSES = '/funding-request/statuses';
  public static readonly ADD_DOCUMENT = '/funding-request/{id}/document';
  public static readonly GL_CODES = '/funding-request/glCodes';
}
